import { Modal, Select } from 'antd'
import Notiflix from 'notiflix';
import { useEffect, useState } from 'react'
import PhoneInput from 'react-phone-number-input'
import PostApiCall from '../Api/PostApi';
import { parsePhoneNumber } from 'react-phone-number-input'
import en from 'react-phone-number-input/locale/en.json'
import "./LodhaForm.css"

const LeadsUpdates = ({ isModalOpen, handleCloseModal, selectedType = '', selectedData = {} }) => {

	const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

	const [mobile, setMobile] = useState("");
	const [isDisable, setIsDisable] = useState(false);
	const [cityOptList, setCityOptList] = useState([]);


	const [formDetails, setFormDetails] = useState({
		firstName: '',
		lastName: '',
		country: '',
		countryCode: '',
		mobileNo: '',
		emailAddress: '',
		cityOfInterest: [],
		budget: '',
		propertyType: [],
		leadStatus: '',
		timelineToInvest: '',
		remarks: '',
		showError: false,
	})
	const [otherCity, setOtherCity] = useState('')

	const listOfCities = ['Mumbai',
		'Pune',
		'Bangalore',
		'Hyderabad',
		'Chennai',
		'Ahmedabad',
		'Gujarat',
		'Vadodara',
		'Goa',
		'Kolhapur',
		'Delhi',
		'Coimbatore',
		'Kolkata',
		'Indore',
		'Dubai',
		'Thane',
		'Nagpur',
		'Aurangabad',
		'Gurugram',
		'Other']

	const handleOnChange = (name, value) => {
		let newValue = value;

		setFormDetails((prev) => ({
			...prev,
			[name]: newValue
		}))
	}

	useEffect(() => {
		if (isModalOpen) {
			if (selectedType) {
				setIsDisable(selectedType === 'View');
				const selectedCities = selectedData?.fld_city_of_interest ? selectedData?.fld_city_of_interest?.split(', ') : [];
				setFormDetails({
					firstName: selectedData?.fld_first_name,
					lastName: selectedData?.fld_last_name,
					country: selectedData?.fld_country,
					countryCode: selectedData?.fld_country_code,
					mobileNo: selectedData?.fld_mobile_number,
					emailAddress: selectedData?.fld_email_address,
					cityOfInterest: selectedCities,
					budget: selectedData?.budget,
					propertyType: selectedData?.fld_property_type ? selectedData?.fld_property_type?.split(',') : [],
					leadStatus: selectedData?.fld_leads_status,
					timelineToInvest: selectedData?.fld_timeline_to_invest,
					remarks: selectedData?.fld_remarks,
					showError: false,
				})

				let updatedCities = [...listOfCities];

				selectedCities.forEach((city) => {
					if (
						city &&
						!updatedCities.some(
							existing => existing.toLowerCase() === city.toLowerCase()
						)
					) {
						updatedCities.push(city);
					}
				});

				setCityOptList(updatedCities);
			} else {
				setCityOptList(listOfCities)
				setIsDisable(false);
				resetValues();
			}
		}
	}, [isModalOpen])

	// const showErrMsg = (value) => {
	// 	if (formDetails?.showError && !value) {
	// 		return <small className='text-danger'></small>
	// 	}
	// }


	const handleValidateForm = () => {
		if (!formDetails?.firstName) {
			Notiflix.Notify.failure("First name is required. Please enter your first name.");
			return;
		}
		if (!formDetails?.mobileNo || formDetails?.mobileNo?.length < 6) {
			Notiflix.Notify.failure('Invalid mobile number.');
			return;
		} if (!formDetails?.emailAddress?.replace(/\s+/g, '') || !emailRegex.test(formDetails?.emailAddress?.replace(/\s+/g, ''))) {
			Notiflix.Notify.failure('Invalid email address.');
			return;
		}
		handleUpdateLeadsDetails();
	};


	const handleUpdateLeadsDetails = async () => {
		Notiflix.Loading.dots("Please Wait...");
		const filteredCityOfInterest = formDetails?.cityOfInterest?.filter((ct) => ct !== 'Other');
		const loginDetails = localStorage.getItem("LoginDetail") ? JSON.parse(localStorage.getItem("LoginDetail"))[0] : {}
		PostApiCall.postRequest(
			{
				leadId: selectedData?.fld_id || null,
				firstName: formDetails?.firstName,
				lastName: formDetails?.lastName,
				country: formDetails?.country,
				countryCode: formDetails?.countryCode,
				mobileNo: formDetails?.mobileNo,
				emailAddress: formDetails?.emailAddress?.replace(/\s+/g, ''),
				cityOfInterest: filteredCityOfInterest?.join(', '),
				budget: formDetails?.budget,
				propertyType: formDetails?.propertyType?.join(', '),
				leadStatus: formDetails?.leadStatus,
				timelineToInvest: formDetails?.timelineToInvest,
				remarks: formDetails?.remarks,
				updatedBy: loginDetails?.fld_userid
			},
			"UpdateVisitorRegistrationLeads"
		).then((result) =>
			result.json().then((obj) => {
				if (result.status == 200 || result.status == 201) {
					resetValues();
					Notiflix.Notify.success("Details Updated Succesfully");
					Notiflix.Loading.remove();
					handleCloseModal('fetch');

				}
			})
		);
	}

	const resetValues = () => {
		setFormDetails({
			firstName: '',
			lastName: '',
			country: '',
			countryCode: '',
			mobileNo: '',
			emailAddress: '',
			cityOfInterest: [],
			budget: '',
			propertyType: [],
			leadStatus: '',
			timelineToInvest: '',
			remarks: '',
			showError: false,
		})
	}


	return (
		<>
			<Modal
				centered
				width={700}
				open={isModalOpen}
				onOk={() => handleCloseModal()}
				onCancel={() => handleCloseModal()}
				footer={false}>
				<div className="row landing-page-modal">
					<div className="col-lg-12">
						<div className="p-3 w-100 visitorformbg bg-white lodha-form">
							<div className='mb-3'>
								<h2 className="mb-2">{(selectedType === 'View') ? 'Visitor Details' : (selectedType === 'Edit') ? 'Update Visitor Details' : 'Add Visitor Details'}</h2>
							</div>
							<div className="row">
								<div className="col-6 mb-3">
									<label>First Name *</label>
									<input
										type="text"
										className="form-control visitor-input py-3"
										value={formDetails?.firstName}
										onChange={(e) => handleOnChange('firstName', e.target.value)}
										readOnly={isDisable}
									/>
									{/* {showErrMsg(formDetails?.firstName)} */}
								</div>
								<div className="col-6 mb-3">
									<label>Last Name</label>
									<input
										type="text"
										className="form-control visitor-input py-3"
										value={formDetails?.lastName}
										onChange={(e) => handleOnChange('lastName', e.target.value)}
										readOnly={isDisable}
									/>
									{/* {showErrMsg(formDetails?.lastName)} */}
								</div>
								<div className="col-6  mb-3 phone-number-input">
									<label>Mobile Number *</label>
									<PhoneInput
										placeholder="Enter phone number"
										value={formDetails?.mobileNo}
										international
										defaultCountry="IN"
										countryCallingCodeEditable={false}

										onChange={(value) => {
											if (isDisable) return;
											handleOnChange("mobileNo", value);

											if (value) {
												const phoneNumber = parsePhoneNumber(value);

												if (phoneNumber) {
													handleOnChange('countryCode', `+${phoneNumber.countryCallingCode}`);
													handleOnChange('country', en[phoneNumber.country]);
												} else {
													handleOnChange('countryCode', '');
													handleOnChange('country', '');

												}
											}
										}}
									// disabled={isDisable}
									/>
								</div>
								<div className="col-6 mb-3">
									<label>Country *</label>
									<input
										type="text"
										className="form-control visitor-input py-3"
										value={formDetails?.country}
										onChange={(e) => handleOnChange('country', e.target.value)}
										disabled={!isDisable}
										readOnly={isDisable}
									/>
									{/* {showErrMsg(formDetails?.country)} */}
								</div>
								{/* <div className="col-6 mb-3">
									<label>Country Code *</label>
									<input
										type="text"
										className="form-control visitor-input py-3"
										value={formDetails?.countryCode}
										onChange={(e) => handleOnChange('countryCode', e.target.value)}
										disabled={!isDisable}
										readOnly={isDisable}
									/>
								</div> */}
								<div className="col-12  mb-3">
									<label>Email *</label>
									<input
										className="form-control visitor-input"
										value={formDetails?.emailAddress}
										onChange={(e) => handleOnChange('emailAddress', e.target.value)}
										readOnly={isDisable}
									/>
									{/* {showErrMsg(formDetails?.emailAddress)} */}
								</div>
								<div className="col-12  mb-3">
									<label>City of Interest</label>
									<Select
										mode="multiple"
										showSearch
										disabled={isDisable}
										value={formDetails?.cityOfInterest}
										className="visitor-input form-control"
										options={cityOptList?.map((city) => ({
											label: city, value: city
										}))}
										optionFilterProp="children"
										onChange={(value) => handleOnChange('cityOfInterest', value)}
										filterOption={(input, option) =>
											(option?.label ?? '')?.toLowerCase()?.includes(input?.toLowerCase())
										}
									/>
								</div>
								{formDetails?.cityOfInterest?.some((det) => det === 'Other') &&
									<div className='d-flex align-items-center gap-2'>
										<div className="col-8  mb-3">
											<label>Other City</label>
											<input
												className="form-control visitor-input"
												value={otherCity}
												onChange={(e) => setOtherCity(e.target.value)}
											// readOnly={isDisable}
											/>
										</div>
										<button
											type="button"
											className="visitor-btn mt-1"
											onClick={() => {
												if (!otherCity) return;

												setCityOptList((prev) =>
													prev.includes(otherCity) ? prev : [...prev, otherCity]
												);

												setFormDetails((prev) => {
													const updatedCities = prev.cityOfInterest
														.filter(city => city !== 'Other') // remove 'Other'
														.concat(
															prev.cityOfInterest.includes(otherCity) ? [] : [otherCity]
														);

													return {
														...prev,
														cityOfInterest: updatedCities,
													};
												});

												setOtherCity('');
											}}
										>
											Add
										</button>
									</div>
								}
								<div className="col-12  mb-3">
									<label>Budget</label>
									<input
										className="form-control visitor-input"
										value={formDetails?.budget}
										onChange={(e) => handleOnChange('budget', e.target.value)}
										readOnly={isDisable}
									/>
									{/* {showErrMsg(formDetails?.budget)} */}
								</div>
								<div className="col-12  mb-3">
									<label>Property Type</label>
									<Select
										showSearch
										mode="multiple"
										className="visitor-input form-control"
										value={formDetails?.propertyType}
										onChange={(value) => handleOnChange('propertyType', value)}
										disabled={isDisable}
									>
										<Select.Option value="Residential">Residential</Select.Option>
										<Select.Option value="Commercial">Commercial</Select.Option>
										<Select.Option value="Plot">Plot</Select.Option>
										<Select.Option value="Shop">Shop</Select.Option>
										<Select.Option value="Villa">Villa</Select.Option>
									</Select>
									{/* {showErrMsg(formDetails?.propertyType)} */}
								</div>
								<div className="col-12  mb-3">
									<label>Lead Status</label>
									<Select
										showSearch
										className="visitor-input form-control"
										value={formDetails?.leadStatus ? [formDetails?.leadStatus] : []}
										onChange={(value) => handleOnChange('leadStatus', value)}
										disabled={isDisable}
									>
										<Select.Option value="Booked">Booked</Select.Option>
										<Select.Option value="Cold">Cold</Select.Option>
										<Select.Option value="Hot">Hot</Select.Option>
										<Select.Option value="Warm Lead">Warm Lead</Select.Option>
									</Select>
									{/* {showErrMsg(formDetails?.leadStatus)} */}
								</div>
								<div className="col-12  mb-3">
									<label>Timeline to Invest </label>
									<Select
										showSearch
										className="visitor-input form-control"
										value={formDetails?.timelineToInvest ? [formDetails?.timelineToInvest] : []}
										onChange={(value) => handleOnChange('timelineToInvest', value)}
										disabled={isDisable}
									>
										<Select.Option value="Immediate">Immediate</Select.Option>
										<Select.Option value="3 Months">3 Months</Select.Option>
										<Select.Option value="6 Months">6 Months</Select.Option>
										<Select.Option value="1 Year">1 Year</Select.Option>
										<Select.Option value="Not Yet Decided">Not Yet Decided</Select.Option>
									</Select>
									{/* {showErrMsg(formDetails?.timelineToInvest)} */}
								</div>
								<div className="col-12  mb-3">
									<label>Remarks</label>
									<textarea
										rows={4}
										className="form-control"
										value={formDetails?.remarks}
										onChange={(e) => handleOnChange('remarks', e.target.value)}
										readOnly={isDisable}
									/>
									{/* {showErrMsg(formDetails?.remarks)} */}
								</div>


								{(selectedType !== 'View') &&
									<div className="mt-1 mb-0 mb-sm-1 pb-3 pb-sm-2 align-self-sm-end">
										<button
											type="button"
											className="visitor-btn"
											onClick={() => handleValidateForm()}
										>
											{selectedType === 'Edit' ? 'Update Details' : 'Add Details'}
										</button>
									</div>}
							</div>
						</div>
					</div>
				</div>
			</Modal>
		</>
	)
}

export default LeadsUpdates